"use client";
import dynamic from "next/dynamic";
import Loader from "@/Layout/Loader";
import { useTranslation } from "@/Utils/Hooks/useTranslate";
import { SocialLinkAPI } from "@/Utils/APIRequest/Endpoints";
import usePost from "@/Utils/Hooks/usePost";
import { CustomToast } from "@/Utils/CustomToast";
import Cookies from "js-cookie";

const FacebookTab = dynamic(() => import('./FacebookTab'), { ssr: false });
const TiktokTab = dynamic(() => import('./TiktokTab'), { ssr: false });
const InstagramTab = dynamic(() => import('./InstagramTab'), { ssr: false });
const YoutubeTab = dynamic(() => import('./YoutubeTab'), { ssr: false });

const RelinkSocialMediaAccounts = (props) => {
  const { selectedSocialType, selectedSocialId, refetchSelf, JobDetailData } = props;
  const { translations } = useTranslation();

  // Link API
  const { mutate: LinkMutate, isPending: LinkPending } = usePost(SocialLinkAPI, null, (response) => {
    if (response.status == 200 || response.status == 201) {
      Cookies.remove("campaign_data");
      refetchSelf();
      CustomToast("success", "Account reauthorized successfully");
    }
    if (response.status == 205) {
      refetchSelf();
      CustomToast("error", translations.accountAlreadyLinked)
    }
    if (response.status == 206) {
      refetchSelf();
      CustomToast("error", translations.accountNotMatchCriteria)
    }
  }, null);

  if (LinkPending) {
    return <Loader />
  }

  return (
    <>
      <div className="rounded-xl relative">
        {selectedSocialType == 'instagram' && <InstagramTab translations={translations} LinkMutate={LinkMutate} selectedSocialId={selectedSocialId} JobDetailData={JobDetailData} />}

        {selectedSocialType == 'facebook' && <FacebookTab translations={translations} LinkMutate={LinkMutate} selectedSocialId={selectedSocialId} />}

        {selectedSocialType == 'youtube' && <YoutubeTab translations={translations} LinkMutate={LinkMutate} selectedSocialId={selectedSocialId} />}

        {selectedSocialType == 'tiktok' && <TiktokTab translations={translations} LinkMutate={LinkMutate} selectedSocialId={selectedSocialId} />}
      </div>
    </>
  );
};
export default RelinkSocialMediaAccounts;